import React from 'react'
import styles from './organisation-creation-form.styles'
import injectSheet from 'react-jss'
import Section from '../../../shared/details/section/section'
import FormRow from '../../../shared/details/form-row/form-row'
import FormCell from '../../../shared/details/form-cell/form-cell'
import FormLabel from '../../../shared/details/form-label/form-label'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import { Formik } from 'formik'
import Button from 'pobble-components/dist/button'
import FormCheckbox from 'pobble-components/dist/form-elements/form-checkbox'

const OrganisationCreationForm = ({ classes, onSubmit }) => (
  <Formik
    onSubmit={onSubmit}
    initialValues={{
      title: '',
      local_authority: false
    }}>
    {formikProps => {
      const {
        values,
        handleBlur,
        handleChange,
        handleSubmit,
        isValid
      } = formikProps
      return (
        <form onSubmit={handleSubmit} className={classes.form}>
          <Section
            title="Creation of an Organisation"
            renderHeader={() => (
              <Button
                className={classes.submitButton}
                disabled={!isValid}
                type="submit"
                tall>
                Submit
              </Button>
            )}>
            <FormRow>
              <FormCell>
                <FormLabel>Title</FormLabel>
                <FormInput
                  name="title"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.title}
                  placeholder={'Ex: Devon'}
                />
              </FormCell>
            </FormRow>
            <FormRow>
              <FormCell>
                <div>
                  <FormLabel htmlFor="local_authority">
                    <FormCheckbox
                      name="local_authority"
                      id="local_authority"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      checked={values.local_authority}
                    />
                    Local authority
                  </FormLabel>
                </div>
              </FormCell>
            </FormRow>
          </Section>
        </form>
      )
    }}
  </Formik>
)

export default injectSheet(styles)(OrganisationCreationForm)
